var ctOutgoingMessagesFormModel;
(function ($) {
 	$.fn.capitechOutgoingMessagesForm = function(options) {
		var $ctOutgoingMessagesFormElm = $(this);
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function sendOutgoingMessagesForm() {
			var message = $ctOutgoingMessagesFormElm.find('#messageTextarea').val();
			var messageDate = new Date();
			
			var success = function success(data, textStatus, jqXHR) {
				var message = $ctOutgoingMessagesFormElm.find('#messageTextarea').val();
				var messageID;
				
				loaderIndicator(false);
				
				if (data.success == true) {
					messageID = data.content[0];
					sweetAlert(getResource('message.sentSuccessTitle', 'Information'), getResource('message.sentSuccessText', 'Message successfully sent.'), "success");
					try {
						ctOutgoingMessagesModel.outgoingMessages.pushFromModel({
							'messageDate': new Date(),
							'messageTime': moment(messageDate).format('HH:mm'),
							'message': message,
							'messageDetail': message,
							'id': messageID,
							'status': 'Created'
						});
						ctOutgoingMessagesModel.outgoingMessages.sort(_sortByTime);
						var message = $ctOutgoingMessagesFormElm.find('#messageTextarea').val('');
						$('.ct-outgoing-messages-tab').tab('show');
					} catch (err) {}
					
				} else {
					sweetAlert(getResource('message.sentFailedTitle', 'Error'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			_api.createMessage_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), message);
		}
		
		// 
		/*////////////////////////////////////////////////////////////*/
		$ctOutgoingMessagesFormElm.submit(function(evt) {
			evt.preventDefault();
			sendOutgoingMessagesForm();
		})
		
	};
}(jQuery));